import API from '@/apis';
import utils from '@/tools/commonUtil'
const formData = {
    listForm: {
        style: '',
        vertical: true,
        body: [
            {
                index: 1, vertical: true,
                // submit: ['quotation', 'listSearch'], 不想用此方法调用
                items: [
                    {
                        index: 0, showlabel: true, label: '关键字查询', placeholder: '输入关键字查询', name: 'search', value: '', type: 'input', filled: false,
                        outlined: true,
                        width: '200px',
                    },
                    {
                        index: 5, label: '查询', type: 'submit', filled: false, outlined: true, showlabel: false,
                        disable: false, variant: { icon: 'fas fa-search' }
                    },
                ]
            },
        ]
    },
    detailForm: {
        style: '',
        vertical: true,
        body: [
            {
                index: 1, vertical: true, submit: ['member', 'fetch-list'],
                items: [

                    {
                        index: 0, showlabel: true, label: '客户内码', placeholder: '', name: 'customer_id', value: '', type: 'input', filled: false, required: true,
                        outlined: true, width: '200px', disable: false
                    },
                    {
                        index: 0, showlabel: true, label: '物料分类ID', placeholder: '', name: 'material_group_id', value: '', type: 'input', filled: false, required: true,
                        outlined: true, width: '200px', disable: false
                    },
                    {
                        index: 0, showlabel: true, label: '标准下浮(%)', placeholder: '', name: 'standard_discount', value: '', type: 'input', filled: false, required: true,
                        outlined: true, width: '200px', disable: false
                    },
                    {
                        index: 0, showlabel: true, label: '特殊下浮(%)', placeholder: '', name: 'special_discount', value: '', type: 'input', filled: false, required: true,
                        outlined: true, width: '200px', disable: false
                    },
                    {
                        index: 0, showlabel: true, label: '备注', placeholder: '', name: 'notes', value: '', type: 'input', filled: false, required: true,
                        outlined: true, width: '200px', disable: false
                    },
             
                ]
            },
        ]
    }
}
const tableData = {
    listTable: {
        table_class: 'layout-table',
        height: '400px',
        separator: 'cell', //表格边框
        // row_key: 'id',
        hidePagination: false,
        dense: true,
        edit: false, //带不带编辑功能
        selection: 'multiple',
        selected: [],
        visibleColumns: [ 
           'customer_id','material_group_id','standard_discount','special_discount','notes'
        ],
        data:[
            {customer_id:'方文成拓',material_group_id:'234SDFSDF98',standard_discount:'20',special_discount:'8',notes:'物料备注信息1'},
            {customer_id:'方文成拓',material_group_id:'657FSDFGFG7',standard_discount:'20',special_discount:'7',notes:'物料备注信息2'},
            {customer_id:'方文成拓',material_group_id:'486GFDGGFD4',standard_discount:'20',special_discount:'8',notes:'物料备注信息3'}
        ],
        columns:[
            {
                check: true, required: false, name: 'customer_id', label: '客户内码', align: 'left', field: 'customer_id', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'material_group_id', label: '物料分类ID', align: 'left', field: 'material_group_id', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'standard_discount', label: '标准下浮(%)', align: 'right', field: 'standard_discount', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'special_discount', label: '特殊下浮(%)', align: 'right', field: 'special_discount', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'notes', label: '备注', align: 'left', field: 'notes', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            
           
        ]
    },
    detailTable: {
        table_class: 'layout-table',
        height: '400px',
        // row_key: 'id',
        separator: 'cell',
        hidePagination: true,
        dense: true,
        edit: true,
        selection: 'multiple',
        selected: [],
        // visibleColumns: ['quotation_id', 'material_name', 'material_model', 'brand', 'material_number', 'date_delivery', 'qty',
        //     'tax_list_price', 'tax_rate', 'list_price', 'standard_discount', 'special_discount', 'discount', 'tax_price', 'price', 'tax_amount',
        //     'tax_deduction', 'amount', 'deduction', 'cost_discount', 'assess_profit', 'profit_rate', 'notes'
        // ],
        visibleColumns: ['index','erp_material_number','material_name','material_model','brand','material_number','unit','list_price','notes'
        ],
        data: [
            {index:'1',id:'01',erp_material_number:'1FK21046AF101MA0',material_name:'伺服电机',material_model:'1FK2104-6AF10-1MA0',brand:'西门子',material_number:'1FK21046AF101MA0',unit:'个',list_price:'100',notes:'这是一条备注信息'},
            {index:'2',id:'02',erp_material_number:'1FK21046AF101MA0',material_name:'伺服电机',material_model:'1FK2104-6AF10-1MA0',brand:'西门子',material_number:'1FK21046AF101MA0',unit:'个',list_price:'100',notes:'这是一条备注信息'},
            {index:'3',id:'03',erp_material_number:'1FK21046AF101MA0',material_name:'伺服电机',material_model:'1FK2104-6AF10-1MA0',brand:'西门子',material_number:'1FK21046AF101MA0',unit:'个',list_price:'100',notes:'这是一条备注信息'}
        ],
        columns: [
            { name: 'index', label: '序号', field: 'index', align: 'center' },
            {
                check: true, required: false, name: 'erp_material_number', label: 'ERP物料编码', align: 'left', field: 'erp_material_number', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
        
            {
                check: true, required: false, name: 'material_name', label: '物料名称', align: 'left', field: 'material_name', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'material_model', label: '规格型号', align: 'left', field: 'material_model', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'brand', label: '品牌', align: 'left', field: 'brand', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'material_number', label: '订货号', align: 'left', field: 'material_number', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'unit', label: '计量单位', align: 'left', field: 'unit', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'list_price', label: '列表价', align: 'right', field: 'list_price', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
            {
                check: true, required: false, name: 'notes', label: '备注', align: 'left', field: 'notes', sortable: true,
                format: (val) => `${val ? val : ''}`, headerClasses: 'my-special-class'
            },
        ],
        tools: {
            active_index: 1,
            btns: [
                {
                    index: 1, label: '新增行', type: 'text', sign: "add", dense: true, flat: true,
                    disable: false, btnClick: false
                },
                {
                    index: 1, label: '删除行', type: 'text', sign: "delete", dense: true, flat: true,
                    disable: false, btnClick: false
                }
            ]
        }
    },
}
const btnData = {
    listBtn: {
        btns: [
            {
                index: 1, label: '新增', type: 'text', sign: "add", dense: true, flat: true,
                disable: false, btnClick: false, variant: { icon: 'fas fa-search' }
            },
            {
                index: 4, label: '删除', type: 'text', sign: "delete", dense: true, flat: true,
                disable: false, variant: { icon: 'fas fa-wrench' }, btnClick: false
            },
            {
                index: 3, label: '|', type: 'separate', sign: "line", dense: true, flat: true,
                disable: false, variant: { icon: 'fas fa-wrench' }, btnClick: false
            },
            {
                index: 5, label: '导入', type: 'text', sign: "import", dense: true, flat: true,
                disable: false, variant: { icon: 'fas fa-wrench' }, btnClick: false
            },

            {
                index: 7, label: '导出', type: 'text', sign: "export", dense: true, flat: true,
                disable: false, variant: { icon: 'fas fa-wrench' }, btnClick: false
            },
            {
                index: 2, label: '详情', type: 'text', sign: "detail", dense: true, flat: true,
                disable: false, variant: { icon: 'fas fa-wrench' }, btnClick: false
            },
        ],
    },

    detailBtn: {
        btns: [
            {
                index: 1, label: '返回', type: 'text', sign: "back", dense: true, flat: true,
                disable: false, btnClick: false,
            },

            {
                index: 1, label: '保存', type: 'text', sign: "save", dense: true, flat: true,
                disable: false, btnClick: false, variant: { icon: 'fas fa-search' }
            },
            {
                index: 2, label: '取消', type: 'text', sign: "cancel", dense: true, flat: true,
                disable: false, btnClick: false
            },

        ]
    }
}

const state = () => ({
    material: Object.assign({}, formData, tableData, btnData)
})

const getters = {
    listForm: state => state.material.listForm,
    detailForm: state => state.material.detailForm,
    listTable: state => state.material.listTable,
    detailTable: state => state.material.detailTable,
    listBtn: state => state.material.listBtn,
    detailBtn: state => state.material.detailBtn,
}
const mutations = {
        //form置空
        initDetailFrom(state) {
            state.material.detailForm.body[0].items = state.material.detailForm.body[0].items.map(item => {
                return {
                    ...item, value: null
                }
            })
        },
        //table置空
        initDetailTable(state) {
            state.material.detailTable.data = []
        },
    //新增行
    addRow(state){
        state.material.detailTable.data.push({
            id: (Math.random() + new Date().getTime()).toString(32).slice(0, 8),
            index: state.material.detailTable.data.length + 1
        })
    }

}
const actions = {

}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}